import { Acervo, Module, type User } from 'api/data.types'

export const isPublic = (user: User): boolean => {
  return rootAcervoMatches(user, Acervo.PUBLIC)
}

export const isFreemium = (user: User): boolean => {
  return rootAcervoMatches(user, Acervo.FREEMIUM)
}

export const isPremium = (user: User): boolean => {
  return user?.reader?.acervos?.includes(Acervo.PREMIUM)
}

export const isEnglish = (user: User): boolean => {
  return rootAcervoMatches(user, Acervo.ENGLISH)
}

export const isEnglishOnly = (user: User): boolean => {
  return rootAcervoMatches(user, Acervo.ENGLISH_ONLY)
}

export const isAdventista = (user: User): boolean => {
  return user?.reader?.acervos?.includes('adventista') ?? false
}

export const hasCriar = (user: User): boolean => {
  return user?.reader?.acervos?.includes('criar') ?? false
}

export const hasLer = (user: User): boolean => {
  return user?.reader?.contentFilters?.includes(Module.LER) ?? false
}

export const rootAcervoMatches = (
  user: User,
  expectedAcervo: string
): boolean => {
  return user?.reader?.root?.root_acervo === expectedAcervo
}

const AcervoUtils = {
  isFreemium,
  isPublic,
  isPremium,
  isEnglishOnly,
  isEnglish,
  isAdventista,
  hasCriar,
  hasLer
}

export default AcervoUtils
